import { forward } from "effector";
import { navigate } from "gatsby";
import { page } from "@lana-commerce/core/analytics";
import { shopDomain } from "@lana-commerce/core/shopDomain";

import {
  $currency,
  setCartCount,
  setCurrency,
  setCustomerInfo,
  setJWT,
  setRecentlyVisitedProducts,
} from "../state/state";
import type { Hooks } from "../state/async/core_impl";
import { ShopData } from "../data/def";
import { UI } from "../state/async/core";

let isFirstPageLoad = true;

export function onPageLoad(shopData: ShopData) {
  page();
  const hooks: Hooks = {
    goToVariant: (info) =>
      shopData.singleLocale
        ? navigate(`/products/${info.productHandle}?variant_id=${info.variantID}`)
        : navigate(`/${shopData.locale}/products/${info.productHandle}?variant_id=${info.variantID}`),
    canonicalVariantURL: shopData.siteUrl ? (info) => `${shopData.siteUrl}/products/${info.productHandle}` : null,
  };
  UI.configureHooks(hooks);
  if (isFirstPageLoad) {
    UI.afterLoad().then((m) => {
      const state = m.state;
      const cartCount = state.cart.lineItems.map((lis) => lis.reduce((acc, li) => acc + li.quantity, 0));
      setCurrency(state.cart.currency.getState());
      setCustomerInfo(state.customer.customerInfo.getState());
      setCartCount(cartCount.getState());
      setJWT(state.jwt.getState());
      setRecentlyVisitedProducts(state.recentlyVisitedProducts.getState());
      forward({ from: state.cart.currency, to: setCurrency });
      forward({ from: state.customer.customerInfo, to: setCustomerInfo });
      forward({ from: cartCount, to: setCartCount });
      forward({ from: state.jwt, to: setJWT });
      forward({ from: state.recentlyVisitedProducts, to: setRecentlyVisitedProducts });
    });

    const stripeGateway = shopData.gateways.find((gw) => gw.type === "stripe")?.stripe;
    UI.load({
      initialCartCurrency: $currency.getState(),
      cdn: shopData.cdn,
      opts: shopData.opts || {},
      oauth2Providers: shopData.shop.customer_oauth_providers,
      shopCurrencies: shopData.currencies,
      shopCurrency: shopData.shop.currency,
      shopDomain: shopDomain(shopData.shop),
      shopID: shopData.shop.id,
      tipsVariantID: shopData.shop.tips_enabled ? shopData.shop.tips_variant?.id : undefined,
      stripe: stripeGateway
        ? {
            accountID: stripeGateway.account_id,
            publishableKey: stripeGateway.publishable_key,
          }
        : undefined,
    });

    isFirstPageLoad = false;
  }
}
